import { DiscountlevelList } from "./DiscountlevelList"
import { DiscountlevelShow } from "./DiscountlevelShow"
import { DiscountlevelEdit } from "./DiscountlevelEdit"

export default {
  list: DiscountlevelList,
  show: DiscountlevelShow,
  edit: DiscountlevelEdit
}